export * from './Page';
import Page from './Page';
export default Page;
